<lib-filters-component [filters_options]="filter_service.filtersType"></lib-filters-component>
<div class="continental-filter-panel" *ngIf="continental_filters_service.regionCombo">
  <app-table-members-search-item
  [image]="getContinentAsset(continent.Continent)|async"
  [isActive]="(continental_filters_service.regionCombo.comboData|async).CaId===continent.CaId" (click)="selectContinent(continent, true)" *ngFor="let continent of continentNames|async" [continent]="continent.Continent">
  </app-table-members-search-item>
</div>
<ng-container *ngIf="(continental_filters_service.individualTeamCombo.comboData|async) as isTeamCombo">
<app-wa-table
  [headerMessage]="headerName"
  [customMsgBox]="customBox"
 [showNoResultsMessageCondition]="(isContinentEmpty | async)"
 [showNoResultsMessage]="customLoadMsg"
 [isSortableFunc]="sortClass"
 [showCondition]="true"
 [headers]="headers(isTeamCombo.Value)"
 [isDataLoading]="((isContinentEmpty | async)) == false ? loading : false"
 [areMoreData]="((isContinentEmpty | async)) === false ? areMoreData() : false"
 (loadMore)="loadMore()"
 [data]="data"
 (headerClick)="changeSort($event)"
>
<app-search-box-table #customBox [subtitle]="'select.continent'|transloco">

</app-search-box-table>
<ng-template [extraClass]="['wa-table__cell--fit-right']" app-column let-ranking>
  <ng-container *ngIf="isTeamCombo.Value === false; else teamRankingTmp">
  <lib-athlete-rank  [rankPrevious]="ranking.RnkOld" [rank]="ranking.Rnk"></lib-athlete-rank>
  <lib-athlete-photo [id]="ranking.Athlete.Id" [isTeam]="false"></lib-athlete-photo>
</ng-container>
  <ng-template #teamRankingTmp>
    <lib-athlete-rank  [rankPrevious]="ranking.RnkOld" [rank]="ranking.Rnk"></lib-athlete-rank>
    <lib-athlete-photo [isTeam]="true" [id]="ranking.Team.NOC"></lib-athlete-photo>
  </ng-template>
</ng-template>
<ng-template  app-column let-ranking>
  <ng-container *ngIf="isTeamCombo.Value === false; else teamNameTmp">
  <lib-athlete-name [fname]="ranking.Athlete.FName" [gname]="ranking.Athlete.GName" [wnameord]="ranking.Athlete.WNameOrd" [id]="ranking.Athlete.Id"></lib-athlete-name>
</ng-container>
<ng-template #teamNameTmp>
  <lib-country-name-flag class="team-column" [noc]="ranking.Team.NOC"></lib-country-name-flag>
</ng-template>
</ng-template>

<ng-template  [extraClass]="[]" app-column let-ranking>
  <ng-container *ngIf="isTeamCombo.Value === false">
  <lib-country-flag [name]="((ranking.Athlete.NOC|countryName)|async)?.CShort" [id]="ranking.Athlete.NOC"> </lib-country-flag>
</ng-container>
</ng-template>
<ng-template  [extraClass]="[]" app-column let-ranking>
<div class="score">{{ranking.Points}}</div>
</ng-template>
<ng-template [extraClass]="['wa-table__cell--fit-left']" app-column let-ranking>
  <div [ngClass]="{'margin-b-34': isIndexSelected(ranking.index)}" class="list-row-item__action" *ngIf="{data:data, showDetails:false} as detail" (click)="selectIndex(ranking.index)">
    <span class="plus-minus {{isIndexSelected(ranking.index) === false ? 'plus-minus--more' : 'plus-minus--less' }}">
    </span>
  </div>
</ng-template>

<ng-template app-column-responsive let-ranking>
  <ng-container *ngIf="isTeamCombo.Value === false; else teamRankingTmp">
    <lib-athlete-rank  [rankPrevious]="ranking.RnkOld" [rank]="ranking.Rnk"></lib-athlete-rank>
    <lib-athlete-photo [id]="ranking.Athlete.Id" [isTeam]="false"></lib-athlete-photo>
  </ng-container>
    <ng-template #teamRankingTmp>
      <lib-athlete-rank  [rankPrevious]="ranking.RnkOld" [rank]="ranking.Rnk"></lib-athlete-rank>
      <lib-athlete-photo [isTeam]="true" [id]="ranking.Team.NOC"></lib-athlete-photo>
    </ng-template>
</ng-template>

<ng-template app-column-responsive let-ranking>
  <ng-container *ngIf="isTeamCombo.Value === false; else teamNameTmp">
    <div>
    <lib-athlete-name [fname]="ranking.Athlete.FName" [gname]="ranking.Athlete.GName" [wnameord]="ranking.Athlete.WNameOrd" [id]="ranking.Athlete.Id"></lib-athlete-name>
  </div>
  <div class="country-mobile">
    <lib-country-flag [name]="((ranking.Athlete.NOC|countryName)|async)?.CShort" [id]="ranking.Athlete.NOC"> </lib-country-flag>
  </div>
  </ng-container>
  <ng-template #teamNameTmp>
    <lib-country-name-flag class="team-column" [noc]="ranking.Team.NOC"></lib-country-name-flag>
  </ng-template>
</ng-template>

<ng-template [extraClass]="['wa-table-simple__cell--right', 'mobile-last']" app-column-responsive let-ranking>
  <div>
    <div class="score score--extra-small">{{ranking.Points}}</div>

  </div>
  <div [ngClass]="{'margin-b-34': isIndexSelected(ranking.index)}" class="list-row-item__action" *ngIf="{data:data, showDetails:false} as detail" (click)="selectIndex(ranking.index)">
    <span class="plus-minus {{isIndexSelected(ranking.index) === false ? 'plus-minus--more' : 'plus-minus--less' }}">
    </span>
  </div>
</ng-template>

<ng-template app-row let-ranking>
  <td colspan="100%" class="wa-table__cell wa-table__cell--fit">
    <div *ngIf="isIndexSelected(ranking.index) === true" [@slideInOut]="animationState">
      <ng-container>
        <app-world-ranking-details [details]="ranking.Details"></app-world-ranking-details>
      </ng-container>
    </div>
  </td>
</ng-template>

</app-wa-table>
</ng-container>
